const dayNumberMap = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

/**
 * Translate a single day of week
 */
export function translateDay(index) {
    return {
        key: `global.weekday.${dayNumberMap[index - 1]}`,
        value: dayNumberMap[index - 1]
    }
}

export function translateDrawSchedule({ getText, lottery }) {
    // Default state, the unknown
    let drawsAt = null,
        drawDays = '',
        drawTime = ''

    if (lottery?.drawDays) {
        // Translate each one we have
        const drawDayList = lottery.drawDays.split(',').map((drawIndex) => {
            const day = translateDay(drawIndex)
            return getText(day.key, day.value)
        })

        // Temp work around to change time format as no timestamp provided
        function convertTime(time) {
            const timeString12hr = new Date('1970-01-01T' + time + 'Z').toLocaleTimeString('en-US', { timeZone: 'UTC', hour12: true, minute: '2-digit', hour: 'numeric' })
            return timeString12hr
        }

        const multipleTimes = lottery.drawTime.includes(',')

        // Join the string together
        drawDays = drawDayList.join(` ${getText('global.text.and', 'and')} `)
        drawTime = multipleTimes ? lottery.drawTime : convertTime(lottery.drawTime)

        // Do we draw every day?
        if (lottery.drawDays === '1,2,3,4,5,6,7') {
            drawsAt = multipleTimes ? { key: 'Lottery.DrawsFromAt', text: 'Draws from {drawTime}' } : { key: 'Lottery.DrawsDailyAt', text: 'Draws daily at {drawTime}' }
        } else {
            drawsAt = { key: 'Lottery.DrawsAt', text: 'Draws {drawDays}, {drawTime}' }
        }

        // Our draw time is spread?
        if (multipleTimes) {
            const drawTimeTally = {}

            // Loop over every time we have
            drawTime.split(',').forEach((splitTime, index) => {
                if (!splitTime) {
                    return
                }

                const time = convertTime(splitTime)
                if (drawTimeTally[time]) {
                    drawTimeTally[time].push(index)
                } else {
                    drawTimeTally[time] = [index]
                }
            })

            drawTime = Object.keys(drawTimeTally)
                .map((groupDrawTime) => {
                    // Calculate the days we're running for
                    const dayList = []

                    // Get the underlying day name (pre-translated)
                    for (const dayIndex of drawTimeTally[groupDrawTime]) {
                        dayList.push(drawDayList[dayIndex])
                    }

                    if (dayList.length > 1) {
                        return `${dayList[0]} ${getText('global.text.to', 'to')} ${dayList[dayList.length - 1]} ${getText('global.text.at', 'at')} ${groupDrawTime}`
                    }

                    return `${dayList[0]} ${getText('global.text.at', 'at')} ${groupDrawTime}`
                })
                .join(` ${getText('global.text.andOn', 'and on')} `)
        }
    }

    return {
        drawsAt,
        drawDays,
        drawTime
    }
}
